import { render, staticRenderFns } from "./HistoryBodyFat.vue?vue&type=template&id=70c1a21e&scoped=true&"
import script from "./HistoryBodyFat.vue?vue&type=script&lang=js&"
export * from "./HistoryBodyFat.vue?vue&type=script&lang=js&"
import style0 from "./HistoryBodyFat.vue?vue&type=style&index=0&id=70c1a21e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c1a21e",
  null
  
)

export default component.exports